export const CustomPrefix = ({ children, style, src, ...props }) => {
    return (
        <img src={src} style={{ height: '5vh' }} />
    )
}
